/**
 * ClientWorkspace page-level type definitions.
 * Re-exports shared types from the components directory and adds page-specific types.
 */

export type {
  ClientWorkspaceFile,
  ClientWorkspaceFolder,
  ClientWorkspaceFolder as ClientWorkspaceFolderNode,
  ActiveViewState,
  SmartViewType,
  AllFilesResponse,
  AllFilesApiResponse,
  AllFilesParams,
  UpdateFilePayload,
  UploadFileItem,
  UploadResultItem,
  UploadApiResponse,
  SmartFolderDeleteConfirmData,
  ClientWorkspaceFileSourceType,
} from "components/Workspace/ClientWorkspace/types";

export {
  SOURCE_COLUMN_KEY,
  SOURCE_LABELS,
  isReadOnlyRole,
  isTeamViewerRole,
  isDealSourcedRow,
} from "components/Workspace/ClientWorkspace/types";

// ── Reducer action types ──

export enum ClientWorkspaceReducerAction {
  SetFiles = "CW_SET_FILES",
  AppendFiles = "CW_APPEND_FILES",
  RemoveFile = "CW_REMOVE_FILE",
  UpdateFileInList = "CW_UPDATE_FILE_IN_LIST",
  SetFolders = "CW_SET_FOLDERS",
  AddFolder = "CW_ADD_FOLDER",
  RemoveFolder = "CW_REMOVE_FOLDER",
  UpdateFolderInList = "CW_UPDATE_FOLDER_IN_LIST",
  SetLoadingFiles = "CW_SET_LOADING_FILES",
  SetLoadingFolders = "CW_SET_LOADING_FOLDERS",
  SetFilesError = "CW_SET_FILES_ERROR",
  SetFoldersError = "CW_SET_FOLDERS_ERROR",
  SetPagination = "CW_SET_PAGINATION",
  ResetState = "CW_RESET_STATE",
}

export interface ClientWorkspaceReducerActionPayload {
  type: ClientWorkspaceReducerAction;
  payload?: unknown;
}

// ── Local state shape ──

export interface ClientWorkspaceState {
  files: ClientWorkspaceFile[];
  folders: ClientWorkspaceFolder[];
  pagination: {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
  };
  isLoadingFiles: boolean;
  isLoadingFolders: boolean;
  filesError: string | null;
  foldersError: string | null;
}
